// Canonical URLs for SEO markup.
//
// voorent.com is served by Apache from prerendered folders (build/delhi/index.html),
// so "/delhi" answers with a 301 to "/delhi/". Canonicals, sitemap entries and
// structured-data URLs must use the final (trailing-slash) form, otherwise every
// one of them points Google at a redirect.
export const SITE_URL = "https://voorent.com";

// "/delhi/furniture" -> "/delhi/furniture/" (root, files and query strings untouched)
export function withTrailingSlash(path) {
  if (!path) return "/";
  const [base, rest] = path.split(/(?=[?#])/);
  if (base === "/" || base.endsWith("/") || /\.[a-z0-9]+$/i.test(base)) return path;
  return `${base}/${rest || ""}`;
}

// "/faq/" -> "/faq" — for looking up per-route metadata keyed without the slash.
export function withoutTrailingSlash(path) {
  if (!path || path === "/") return "/";
  return path.replace(/\/+$/, "") || "/";
}

// Absolute canonical URL for a site path or an existing voorent.com URL.
export function canonicalUrl(pathOrUrl) {
  if (!pathOrUrl) return null;
  if (/^https?:\/\//i.test(pathOrUrl)) {
    if (!pathOrUrl.startsWith(SITE_URL)) return pathOrUrl;
    return `${SITE_URL}${withTrailingSlash(pathOrUrl.slice(SITE_URL.length) || "/")}`;
  }
  return `${SITE_URL}${withTrailingSlash(pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`)}`;
}
